import React from "react";
import MuiLink from "@mui/material/Link";

export interface LegalLinkProps {
  href?: string | null;
  children: React.ReactNode;
}

// Renders as a link only when a URL is configured for this tenant (Strapi's
// login_page_style.termsAndConditionsUrl / privacyPolicyUrl) — falls back to
// plain text otherwise. stopPropagation keeps opening the link from also
// toggling the checkbox it's nested inside.
const LegalLink = ({ href, children }: LegalLinkProps): JSX.Element =>
  href ? (
    <MuiLink href={href} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>
      {children}
    </MuiLink>
  ) : (
    <>{children}</>
  );

export default LegalLink;
